import * as yup from 'yup'

function validateTimeFormat(value?: string) {
  if (!value) return true // Let required() handle empty values

  const timeRegex = /^([01]?\d|2[0-3]):[0-5]\d$/
  return timeRegex.test(value)
}

declare module 'yup' {
  interface StringSchema {
    /**
     * @description Validates that the string is a valid time format (00:00 - 23:59)
     * @param message - The message to display if the time format is invalid
     * @returns The schema
     */
    timeFormat(message: string): this
  }
}

yup.addMethod(yup.string, 'timeFormat', function (message: string) {
  return this.test('validateTimeFormat', message, validateTimeFormat)
})

export {}
